/**
 * Lightbox de imagen única — .ip-vida (Inicial) y .prim-galeria (Primaria).
 */
export function marianistaInitIpVidaLightbox() {
  const lightbox = document.getElementById('secLightbox');
  const lbImg = document.getElementById('secLightboxImg');
  const lbClose = document.getElementById('secLightboxClose');
  const lbBackdrop = document.getElementById('secLightboxBackdrop');
  const triggers = document.querySelectorAll('[data-ip-vida-lightbox], [data-prim-galeria-lightbox]');

  if (!lightbox || !lbImg || triggers.length === 0) {
    return;
  }

  function openLightbox(src, alt) {
    if (!src) {
      return;
    }
    lbImg.src = src;
    lbImg.alt = alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lbClose?.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lbImg.removeAttribute('src');
  }

  triggers.forEach((btn) => {
    let startX = 0;
    let startY = 0;
    let dragged = false;

    btn.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      dragged = false;
    });

    btn.addEventListener('pointermove', (e) => {
      if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) {
        dragged = true;
      }
    });

    btn.addEventListener('click', (e) => {
      if (dragged) {
        return;
      }
      e.preventDefault();
      const src = btn.getAttribute('data-full') || btn.querySelector('img')?.getAttribute('src') || '';
      const alt = btn.getAttribute('data-alt') || btn.querySelector('img')?.getAttribute('alt') || '';
      openLightbox(src, alt);
    });
  });

  lbClose?.addEventListener('click', closeLightbox);
  lbBackdrop?.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });
}
